"use client";
import { jsxs as i, jsx as t } from "react/jsx-runtime";
import { useState as o, useEffect as c } from "react";
const r = ["Thinking", "Looking for content", "Analyzing"];
function d() {
  const [n, s] = o(0);
  return c(() => {
    const e = setInterval(() => {
      s((a) => a + 1 < r.length ? a + 1 : (clearInterval(e), a));
    }, 3500);
    return () => clearInterval(e);
  }, []), /* @__PURE__ */ i(
    "div",
    {
      className: "flex items-center space-x-2 font-medium text-sm text-gray-700 dark:text-gray-dark-300",
      "aria-live": "polite",
      children: [
        /* @__PURE__ */ t("span", { className: "animate-shimmer bg-gradient-to-br from-gray-700 to-gray-400 dark:from-gray-dark-300 dark:to-gray-dark-100 bg-clip-text text-transparent", children: r[n] }),
        /* @__PURE__ */ t("div", { className: "flex space-x-1", children: [0, 1, 2].map((e) => /* @__PURE__ */ t(
          "span",
          {
            className: "animate-bounce-dot opacity-30",
            style: {
              animationDelay: `${e * 0.2}s`
            },
            children: "."
          },
          e
        )) })
      ]
    }
  );
}
export {
  d as LoadingIndicator
};
